import React from "react";
import Popup from "./AppPopup";
import Button from "devextreme-react/button";
import "../../styles/CommonPopups.scss";

const ConfirmPopup = ({
  visible,
  title = "Confirm Action",
  message = "Are you sure you want to continue?",
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "No",
}) => {
  return (
    <Popup
      visible={visible}
      dragEnabled={true}
      showCloseButton={true}
      showTitle={true}
      title={title}
      width={400}
      height="auto"
      onHiding={onCancel}
    >
      <div className="confirm-popup__body">
        <p className="confirm-popup__message">{message}</p>
        <div className="confirm-popup__actions">
          <Button
            text={cancelText}
            stylingMode="outlined"
            type="danger"
            onClick={onCancel}
          />
          <Button
            text={confirmText}
            type="default"
            stylingMode="contained"
            onClick={onConfirm}
          />
        </div>
      </div>
    </Popup>
  );
};

export default ConfirmPopup;